/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D checkbox button
 */

import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";

function Checkbox({
    checked,
    disabled = false,
    side,
    text,
    textWidth,
    uncheckedColor = "#000",
    checkedColor = "#0366B2",
    textColor = "#c6c6c6",
    setChecked,
    borderColor = "#737373",
    textSize = "p1",
    id,
    aframeClasses,
    ...otherAttributes
}) {
    return (
        <a-entity
            class="Checkbox"
            onClick={() => {
                if (disabled) return;
                setChecked(id, !checked);
            }}
            {...otherAttributes}
        >
            <a-plane
                position={`0 0 ${side / 50}`}
                width={side}
                height={side}
                color={borderColor}
                class={aframeClasses}
            >
                <a-plane
                    width={side * 0.9}
                    height={side * 0.9}
                    position={`0 0 ${side / 50}`}
                    color={!checked || disabled ? uncheckedColor : checkedColor}
                >
                    {checked && (
                        <a-image
                            width={side * 0.8}
                            height={side * 0.8}
                            position={`0 0 ${side / 50}`}
                            src="#CheckboxMark"
                        ></a-image>
                    )}
                </a-plane>
                {text && (
                    <Text
                        align="left"
                        width={textWidth * 0.9}
                        size={textSize}
                        baseline="center"
                        text={text}
                        color={textColor}
                        position={`${textWidth * 0.1} 0 0.001`}
                    />
                )}
            </a-plane>
        </a-entity>
    );
}

Checkbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    setChecked: PropTypes.func.isRequired,
    side: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Checkbox;
